import type { IFilterTag } from '../types';

const buildColumnsTag = (count: number): IFilterTag => ({
  key: 'columns',
  label: `${ count } ${ count === 1 ? 'column' : 'columns' } selected`,
  isExclude: false,
  removable: false,
});

export default buildColumnsTag;
